/** Hooks e utilidades das telas de compras e contas a pagar. */
import type { Page, PaymentMethod, PurchaseEntry } from "@cafegestor/shared";
import { toFormNumber } from "@cafegestor/shared";
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";

export const ENTRY_KEY = ["compras", "entradas"];

export function useEntry(id: string) {
  return useQuery({
    queryKey: [...ENTRY_KEY, "detalhe", id],
    queryFn: () => apiFetch<PurchaseEntry>(`/compras/entradas/${id}`),
  });
}

export function usePaymentMethods() {
  return useQuery({
    queryKey: ["cadastros", "formas-pagamento", "ativas"],
    queryFn: () =>
      apiFetch<Page<PaymentMethod>>("/cadastros/formas-pagamento?status=active&limit=100"),
    staleTime: 60_000,
  });
}

/** Chave de acesso em blocos de 4 (como no DANFE). */
export const formatAccessKey = (key: string | null) =>
  key ? key.replace(/(\d{4})(?=\d)/g, "$1 ") : "—";

export const bytes = (n: number) =>
  n < 1024
    ? `${n} B`
    : n < 1024 * 1024
      ? `${(n / 1024).toFixed(0)} KB`
      : `${(n / 1024 / 1024).toFixed(1)} MB`;

/** Texto de quantidade para campo de edição ("1.250,5" → "1250,5"). */
/** Número da API para um campo ("1250.5" → "1.250,5"). */
export const toInputQty = (v: string | null | undefined) => toFormNumber(v);
